import { writable } from 'svelte/store';
export const storeUsers = writable([]);
export const storeUsersError = writable("");
export const storeIsLogin = writable(false);
export const storeUserLogin = writable();
export const storeUserEmpty = {
    id: 0,
    email: "",
    first_name: "",
    last_name: "",
    photo: "",
    enterprise: 0,
    linkedin: "",
    twitter: "",
    job: "",
    user_type: 0,
    active: 0,
    token: "",
};
